module.exports = __webpack_public_path__ + "img/zuqiu.3bca0ce3.png";